import React from "react";
import { useEffect, useRef } from 'react';

type MarketingClientViewProps = {
    imageUrls: string[];
}


const MarketingClientView = ({imageUrls} : MarketingClientViewProps) => {
    const scrollRef = useRef<HTMLDivElement>(null);
type MarketingClientViewProps = {
    imageUrls: string[];
}

    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (!scrollContainer) return;

        let scrollAmount = 0;
        const scrollStep = 1;
        const scrollSpeed = 8;

        const scroll = () => {
            scrollAmount += scrollStep;
            scrollContainer.scrollLeft = scrollAmount;

            const firstSetWidth = scrollContainer.scrollWidth / 2;
            if (scrollAmount >= firstSetWidth) {
                scrollAmount = 0;
                scrollContainer.scrollLeft = 0;
            }
        };

        const intervalId = setInterval(scroll, scrollSpeed);

        return () => clearInterval(intervalId);
    }, [imageUrls]);

    return (
        <div className="marketing-client-container-box overflow-hidden relative">
            <div 
                ref={scrollRef}
                className="flex overflow-x-hidden"
                style={{ scrollBehavior: 'auto' }}
            >
                {imageUrls.map((url, index) => (
                    <div key={`first-${index}`} className="marketing-client-box flex-shrink-0 w-40 h-24 bg-white rounded-lg shadow-gray-200 flex items-center justify-center shadow-md mx-2">
                        <img src={url} alt={`Marketing client ${index}`} className="w-[120px] h-[80px] object-contain"/>
                    </div>
                ))}
                {imageUrls.map((url, index) => (
                    <div key={`second-${index}`} className="marketing-client-box flex-shrink-0 w-40 h-24 bg-white rounded-lg shadow-gray-200 flex items-center justify-center shadow-md mx-2">
                        <img src={url} alt={`Marketing client ${index}`} className="w-[120px] h-[80px] object-contain"/>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default MarketingClientView;